// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"ImageCard-module--cardContainer--1wYop","cardImage":"ImageCard-module--cardImage--eD2XS","contentContainer":"ImageCard-module--contentContainer--xfQqV"};